import type { ElementType } from 'react';

import TRAVELLER_INFO from '../../TravellerInfoMapping';

import cleanlinessRatingIcon from './cleanliness-rating.svg';
import locationRatingIcon from './location-rating.svg';
import serviceRatingIcon from './service-rating.svg';

import type { TranslationKey } from '@shared/constants/translations';
import type { ObjectMapping } from '@shared/types/utils';

export const TRANSLATION_KEY_MAPPING: ObjectMapping = {
  location: 'hotel_rating_location',
  cleanliness: 'hotel_rating_cleanliness',
  service: 'hotel_rating_service',
};

export const SELECTION = ['location', 'service', 'cleanliness'];

export const ICON_URL_MAPPING: ObjectMapping = {
  RATING_TYPE_LOCATION: locationRatingIcon,
  RATING_TYPE_SERVICE: serviceRatingIcon,
  RATING_TYPE_CLEANLINESS: cleanlinessRatingIcon,
};

export const REVIEWS_LIST_KEY_MAPPING: ObjectMapping = {
  location: 'HotelDetails_review_confident_list_location',
  cleanliness: 'HotelDetails_review_confident_list_cleanliness',
  service: 'HotelDetails_review_confident_list_service',
};

type SingleRecommend = {
  key: TranslationKey;
  icon: ElementType;
};

type RecommendReviews = {
  [key: string]: SingleRecommend;
};

export const RECOMMEND_TYPE_MAP: RecommendReviews = {
  family: {
    key: 'HotelDetail_label_recommended_family',
    icon: TRAVELLER_INFO.family.icon,
  },
  business: {
    key: 'HotelDetail_label_recommended_business',
    icon: TRAVELLER_INFO.business.icon,
  },
  couple: {
    key: 'HotelDetail_label_recommended_couple',
    icon: TRAVELLER_INFO.couple.icon,
  },
  solo: {
    key: 'HotelDetail_label_recommended_solo',
    icon: TRAVELLER_INFO.solo.icon,
  },
  recommend: {
    key: 'HotelCard_label_most_recommended_num',
    icon: TRAVELLER_INFO.family.icon,
  },
};
